import { createFileRoute } from "@tanstack/react-router";
import RegenceInsurance, { config } from "@/pages/RegenceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/regence-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Regence TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Regence Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Regence TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Regence Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/regence-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/regence-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <RegenceInsurance />;
}
